export default __webpack_public_path__ + "static/circle-142a13e56b0eb0dbb4d5860c14c2ad58.png";